var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0C2.2375 0 0 2.2375 0 5C0 7.7625 2.2375 10 5 10C7.7625 10 10 7.7625 10 5C10 2.2375 7.7625 0 5 0ZM7.5 6.7925L6.7925 7.5L5 5.7075L3.2075 7.5L2.5 6.7925L4.2925 5L2.5 3.2075L3.2075 2.5L5 4.2925L6.7925 2.5L7.5 3.2075L5.7075 5L7.5 6.7925Z",
    fill: "#D50000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormError);
export default __webpack_public_path__ + "static/media/formError.00f52c32ab748a07a1f68a2b3f3b48c0.svg";
export { ForwardRef as ReactComponent };